import { useTranslation } from 'react-i18next';
import { Calendar } from 'lucide-react';
import { formatDate } from '~/utils';

export function ConfirmedShippingCard({
  shippedDate,
  deliveryStartDate,
  deliveryEndDate,
}: {
  shippedDate?: string | null;
  deliveryStartDate?: string | null;
  deliveryEndDate?: string | null;
}) {
  const { t } = useTranslation('order');

  return (
    <div
      className="bg-blue-50 rounded-lg p-4 border border-blue-200"
      data-testid="confirmed-shipping-card"
    >
      <div className="flex items-start gap-2 mb-2">
        <Calendar size="18" className="text-blue-600" />
        <div className="flex-1">
          <p className="text-sm font-medium text-blue-900 mb-1">
            {t('order.expected_shipping_information')}
          </p>
          <div className="space-y-1">
            <p
              className="text-xs text-blue-700"
              data-testid="expected-ship-date"
            >
              <span className="font-medium">
                {t('order.initial_ship_date')}
              </span>{' '}
              {shippedDate && <span>{formatDate(shippedDate)}</span>}
            </p>
            <p
              className="text-xs text-blue-700"
              data-testid="expected-delivery-dates"
            >
              <span className="font-medium">
                {t('order.expected_delivery')}
              </span>{' '}
              {deliveryStartDate && (
                <span>{formatDate(deliveryStartDate)}</span>
              )}
              {deliveryEndDate && <span> - {formatDate(deliveryEndDate)}</span>}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
